import {
  Component,
  ViewContainerRef,
  OnInit,
  ViewChild,
  ElementRef,
  AfterContentChecked,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../accountant.service";
import { DashboardService } from "../../../dashboard.service";
import { UntypedFormBuilder, UntypedFormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormUtil } from "../../../../utils/formutils";
import { HotToastService } from "@ngneat/hot-toast";
import { DragulaService, DragulaModule } from "ng2-dragula";
import * as _ from "underscore";
import { ResourceSearchPipe } from "../../common/resources.pipes";
import { ResourcesItemComponent } from "../../common/resources-item.component";
import { NgIf, NgFor, NgClass } from "@angular/common";

/* This is a component which we pass in modal*/
@Component({
    selector: "app-modal-manage-resources",
    templateUrl: "./manage-resources-modal.component.html",
    providers: [DragulaService],
    imports: [
        NgIf,
        DragulaModule,
        NgFor,
        ResourcesItemComponent,
        FormsModule,
        NgClass,
        ReactiveFormsModule,
        ResourceSearchPipe,
    ]
})
export class ManageResourcesModalComponent implements OnInit, OnChanges {
  isForDefault: boolean = false;
  company_resources: any = [];
  global_resources: any = [];
  practice_resources: any = [];
  global_resources_list: any = [];
  fixed_global_resources: any = [];
  fixed_practice_resources: any = [];
  company_id: any;
  current_client: any;

  addResourceForm: UntypedFormGroup;
  formUtil: FormUtil;
  fileForm: FormData = new FormData();
  showAddResource: boolean;
  search = "";
  current_library = { name: "Global Library", bucket: this.global_resources };

  dragulaOptions: any = {
    direction: "horizontal",
  };

  @ViewChild("resourceInput", { static: true }) resourceInput: ElementRef;

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private dashboardService: DashboardService,
    private formBuilder: UntypedFormBuilder,
    private toastr: HotToastService,
    vcr: ViewContainerRef,
    private dragulaService: DragulaService
  ) {
    this.addResourceForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      description: [null, []],
      file: [null, []],
      // category: [
      //     null,
      //     []
      // ],
      file_type: [null, [Validators.required]],
      url: [null, []],
    });
  }

  ngOnInit(): void {
    this.dragulaService.createGroup("bag-resources-client", {
      direction: "horizontal",
    });

    this.showAddResource = false;
    // Subscription to the drop event from dragula. Used to calculate the order and update it
    // in the backend
    this.dragulaService
      .drop("bag-resources-client")
      .subscribe(({ name, el, target, source, sibling }) => {
        if (name === "bag-resources-client") {
          let order = 0;
          this.company_resources.forEach((v) => {
            v.order = order;
            order++;
          });

          this.accountantService
            .update_company_resource_order(
              this.current_client.id,
              this.company_resources
            )
            .then(
              (res) => {
                const response = res;
              },
              (err) => {
                console.log(err);
              }
            );
        }
      });
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.fixed_global_resources = changes.fixed_global_resources;
    this.fixed_practice_resources = changes.fixed_practice_resources;
    this.global_resources = changes.global_resources;
    this.practice_resources = changes.practice_resources;
    this.fixed_global_resources = changes.fixed_global_resources;
    this.fixed_practice_resources = changes.fixed_practice_resources;
    this.company_id = changes.company_id;
    this.current_client = changes.current_client;
    this.company_resources = changes.company_resources;

    this.current_library.bucket = this.global_resources;
  }

  public addResourceScreen(value) {
    this.showAddResource = value;
  }

  add_company_resource(resource, index): void {
    if (this.isForDefault) {
      this.add_company_default_resource(resource, index);
      return;
    }
    this.dashboardService.show_loading.next(true);
    console.log(resource);
    this.accountantService
      .add_company_resource(this.current_client.id, resource.id)
      .then((res) => {
        const response = res;
        resource.order = response.order;
        resource.company_resource_id = response.company_resource_id;
        this.company_resources.push(resource);
        this.current_library.bucket.splice(index, 1);
        this.dashboardService.show_loading.next(false);
      });
  }

  add_company_default_resource(resource, index): void {
    this.dashboardService.show_loading.next(true);
    this.accountantService
      .add_company_default_resource(resource.id)
      .then(({ order, company_id }: any) => {
        resource.order = order;
        resource.company_app_id = company_id;
        this.company_resources.push(resource);
        this.current_library.bucket.splice(index, 1);
        this.dashboardService.show_loading.next(false);
        this.toastr.success("Default resource added successfully");
      });
  }

  delete_company_resource(resource, index): void {
    if (this.isForDefault) {
      this.delete_company_default_resource(resource, index);
      return;
    }
    this.dashboardService.show_loading.next(true);
    this.accountantService
      .delete_company_resource(this.current_client.id, resource.id)
      .then((res) => {
        this.current_library.bucket.push(resource);
        this.company_resources.splice(index, 1);
        this.dashboardService.show_loading.next(false);
      });
  }

  delete_company_default_resource(resource, index): void {
    this.dashboardService.show_loading.next(true);
    this.accountantService
      .delete_company_default_resource(resource.id)
      .then((res: any) => {
        if (resource.company == null) {
          this.current_library.bucket.push(resource);
        } else {
          if (this.current_library.name === "Practice Library") {
            this.current_library.bucket.push(resource);
          } else {
            this.practice_resources.push(resource);
          }
        }
        this.company_resources.splice(index, 1);
        this.dashboardService.show_loading.next(false);
        this.toastr.success("Default resource deleted successfully");
      });
  }

  saveResource(): void {
    this.dashboardService.show_loading.next(true);
    this.fileForm = new FormData();
    if (this.addResourceForm.valid) {
      if (this.resourceInput !== undefined) {
        const fileList: FileList = this.resourceInput.nativeElement.files;
        if (fileList.length > 0) {
          const file: File = fileList[0];
          this.fileForm.append("file", file, file.name);
        }
      }

      this.fileForm.append("name", this.addResourceForm.get("name").value);
      this.fileForm.append("category", "");
      this.fileForm.append("url", this.addResourceForm.get("url").value);
      this.fileForm.append(
        "file_type",
        this.addResourceForm.get("file_type").value
      );
      this.fileForm.append(
        "description",
        this.addResourceForm.get("description").value
      );
      this.fileForm.append("company_id", this.company_id);

      this.accountantService.add_resource(this.fileForm).then(
        (res) => {
          this.toastr.success("Resource added successfully!");
          if (this.resourceInput !== undefined) {
            this.resourceInput.nativeElement.value = "";
          }

          this.practice_resources.unshift(res.resource);
          this.showAddResource = false;
          this.dashboardService.show_loading.next(false);
        },
        (err) => {
          console.log(err);
          this.dashboardService.show_loading.next(false);
          this.toastr.error(err.error.message);
        }
      );
    }
  }

  change_library(type): void {
    if (type === "global") {
      this.global_resources = _.filter(
        this.fixed_global_resources,
        (obj: any) => {
          return !_.findWhere(this.company_resources, { id: obj.id });
        }
      );

      this.current_library.bucket = this.global_resources;
      this.current_library.name = "Global Library";
    } else if (type === "practice") {
      this.practice_resources = _.filter(
        this.fixed_practice_resources,
        (obj: any) => {
          return !_.findWhere(this.company_resources, { id: obj.id });
        }
      );

      this.current_library.bucket = this.practice_resources;

      this.current_library.name = "Practice Library";
    }
  }
}
